import { environment } from 'services/apiConfigs';

import { sendAnalyticsEvent } from 'features/analytics/analytics.services';

export const analytics = (_, event, properties) => {
  environment === 'production' && sendAnalyticsEvent(event, properties);
  // for testing purposes:
  // environment !== 'production' && sendAnalyticsEvent(event, properties);
};



// WEBPACK FOOTER //
// ./src/app/features/analytics/analytics.actions.js